import React, { useEffect } from "react";
import { Container, Topbar, Button, ProgressSteps } from "@bsf/force-ui";
import { Link } from "../../router/link";
import { routes } from "../../admin/settings/routes";
import { X } from "lucide-react";
import { __ } from "@wordpress/i18n";
import Welcome from "./Welcome";
import General from "./General";
import SocialProfiles from "./SocialProfiles";
import Create from "./Create";

const steps = [
	{ label: "Welcome", component: Welcome },
	{ label: "General", component: General },
	{ label: "Social", component: SocialProfiles },
	{ label: "Create", component: Create },
];

const Onboarding = () => {
	const [currentStep, setCurrentStep] = React.useState(() => {
		const savedStep = localStorage.getItem("currentStep");
		return savedStep ? parseInt(savedStep, 10) : 1;
	});

	useEffect(() => {
		localStorage.setItem("currentStep", currentStep);
	}, [currentStep]);

	useEffect(() => {
		const timer = setTimeout(() => {
			localStorage.removeItem("currentStep");
		}, 180000); // 3 minutes in milliseconds

		return () => clearTimeout(timer); // Clear the timeout if the component unmounts
	}, []);

	const StepComponent = steps[currentStep - 1]?.component;

	return (
		<div>
			<div className="w-full pb-10">
				<div className="flex flex-col items-center justify-center">
					<Topbar className="bg-none" style={{ background: "none" }}>
						<Topbar.Left>
							<Topbar.Item>
								{schemaSettingsData.logo_url && (
									<Link >
										<img
											src={`${schemaSettingsData.logo_url}`}
											alt="Logo"
											className="cursor-pointer h-5"
											onClick={() =>
												(window.location.href =
													schemaSettingsData.wpsp_schema_dashboard_url)
											}
										/>
									</Link>
								)}
							</Topbar.Item>
						</Topbar.Left>
						<Topbar.Middle>
							<Topbar.Item>
								<ProgressSteps
									currentStep={currentStep}
									className="schema-steps"
									variant="dot"
								>
									{steps.map((step, index) => (
										<ProgressSteps.Step
											key={index}
											className="font-bold"
											labelText={step.label}
											size="md"
										/>
									))}
								</ProgressSteps>
							</Topbar.Item>
						</Topbar.Middle>
						<Topbar.Right>
							<Topbar.Item>
								<Link
									className="schema-remove-ring"
									style={{ marginLeft: "125px" }}
								>
									{" "}
									<Button
										icon={<X size={26} />}
										iconPosition="right"
										size="md"
										variant="ghost"
										className="schema-remove-ring"
                                        onClick={() =>
                                            (window.location.href =
                                                schemaSettingsData.wpsp_schema_dashboard_url)
                                        }
									></Button>
								</Link>
							</Topbar.Item>
						</Topbar.Right>
					</Topbar>
				</div>
			</div>

			<div className="flex items-center justify-center">
				{StepComponent && (
					<StepComponent
						currentStep={currentStep}
						setCurrentStep={setCurrentStep}
					/>
				)}
			</div>
		</div>
	);
};

export default Onboarding;
